module.exports = __webpack_public_path__ + "static/img/dami.117d50d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/case/dami.png
// module id = b6OS
// module chunks = 34